import type { FC } from "react";

import { ResponsiveImage } from "@ui/components/ResponsiveImage";
import classNames from "classnames";

import type { FlavorFinderAnswerDetails } from "../../types/FlavorFinderTypes";
import { FlavorFinderAnswerButton } from "../Buttons/FlavorFinderButtons";

import "./FlavorFinderAnswer.scss";

type FlavorFinderAnswerProps = {
  answer: FlavorFinderAnswerDetails;
  isActive: boolean;
  onAnswerClick: (id: string) => void;
};

export const FlavorFinderAnswer: FC<FlavorFinderAnswerProps> = ({ answer, isActive = false, onAnswerClick }) => {
  const {
    backgroundImage = "",
    tabletBackgroundImage = "",
    mobileBackgroundImage = "",
    title,
    subtitle,
    id = "",
  } = answer;

  return (
    <button
      className={classNames("flavorfinder__answer-container", {
        "flavorfinder__answer-container--active": isActive,
      })}
      onClick={() => onAnswerClick(id)}
    >
      <ResponsiveImage
        alt={title}
        largeSrc={backgroundImage}
        mediumSrc={tabletBackgroundImage}
        smallSrc={mobileBackgroundImage}
        className={"responsive-image__container"}
      />
      <FlavorFinderAnswerButton title={title} subtitle={subtitle} isActive={isActive} />
    </button>
  );
};
